import { boardingHighlights, boardingImage } from "@/mocks/homeData";
import {
  BOARDING_MAP_EMBED,
  BOARDING_MAP_LINK,
  BOARDING_POINT_NAME,
} from "@/pages/home/constants";

export default function BoardingPoint() {
  return (
    <section id="embarque" className="relative py-7 md:py-12 bg-background-100 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-4 md:mb-6 reveal">
            <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-2">
              Onde o passeio começa
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-primary-900 mb-2">
              Nosso Ponto de Embarque em Capitólio
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 max-w-xl mx-auto">
              Embarque no <strong>{BOARDING_POINT_NAME}</strong>, com toda a estrutura para o seu conforto.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-8 items-center mb-4 md:mb-5">
            <div className="reveal flex justify-center">
              <div className="relative w-full max-w-xs sm:max-w-sm aspect-[4/3] rounded-2xl overflow-hidden">
                <img
                  src={boardingImage}
                  alt={BOARDING_POINT_NAME}
                  title={`Eco Tour Turismo - Ponto de embarque ${BOARDING_POINT_NAME}`}
                  className="w-full h-full object-cover"
                />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1.5 text-[10px] md:text-xs font-bold text-primary-950 whitespace-nowrap">
                  <i className="ri-anchor-line text-sm" />
                  Ponto de embarque oficial
                </span>
              </div>
            </div>

            <div className="reveal reveal-delay-2">
              <h3 className="text-lg md:text-2xl font-heading font-bold text-primary-900 mb-1.5">
                {BOARDING_POINT_NAME}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-3.5">
                Um complexo completo à beira do Lago de Furnas, pensado para você chegar, se preparar e
                embarcar com todo o conforto e tranquilidade.
              </p>

              <div className="grid grid-cols-2 gap-2.5 md:gap-3">
                {boardingHighlights.map((item) => (
                  <div
                    key={item.id}
                    className="bg-background-50 rounded-xl border border-background-200/70 p-2.5 md:p-3"
                  >
                    <span className="w-8 h-8 md:w-9 md:h-9 rounded-full bg-accent-100 flex items-center justify-center mb-1.5">
                      <i className={`${item.icon} text-accent-700 text-base md:text-lg`} />
                    </span>
                    <h4 className="text-xs md:text-sm font-heading font-bold text-primary-900 mb-0.5">
                      {item.title}
                    </h4>
                    <p className="text-[10px] md:text-xs text-foreground-500 leading-relaxed">
                      {item.description}
                    </p>
                  </div>
                ))}
              </div>

              <a
                href={BOARDING_MAP_LINK}
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="mt-4 inline-flex items-center gap-2 px-5 py-2.5 rounded-md text-xs md:text-sm font-bold bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                <i className="ri-navigation-line text-base" />
                Traçar rota no Google Maps
              </a>
            </div>
          </div>

          <div className="reveal max-w-md mx-auto">
            <div className="rounded-2xl overflow-hidden border border-background-200/70">
              <iframe
                title={`Localização - ${BOARDING_POINT_NAME}`}
                src={BOARDING_MAP_EMBED}
                className="w-full h-40 md:h-48 border-0"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>
            <p className="text-[11px] md:text-xs text-foreground-500 text-center mt-2.5 flex items-center justify-center gap-1.5">
              <i className="ri-map-pin-2-line text-accent-600" />
              Eco Tour Turismo — Capitólio/MG
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}